import { useMemo } from 'react';
import useAxiosPrivate from './useAxiosPrivate';
import { axiosIntegrationInstance } from '../services/axios';
import ScribeServices from '../services/ScribeServices';

const useScribeService = () => {
  const axios = useAxiosPrivate(axiosIntegrationInstance);
  return useMemo(() => new ScribeServices(axios), [axios]);
};

export default useScribeService;
